<template>
  <el-dialog v-dialog-drag :title="title" :visible.sync="showDialog" width="900px" append-to-body :destroy-on-close="true" :before-close="cancel">
    <div class="el-dialog-div">
      <div class="section-card">
        <div class="section-header-bar">
          <div class="section-title"><i class="el-icon-s-ticket"></i> 发票信息</div>
        </div>
        <div class="detail-grid">
          <div class="detail-item">
            <span class="detail-label">审核状态</span>
            <span class="detail-value">
              <el-tag v-if="auditStatus === 'SUCCESS'" type="success" size="small">已通过</el-tag>
              <el-tag v-else-if="auditStatus === 'APPLYING'" type="warning" size="small">待审核</el-tag>
              <el-tag v-else-if="auditStatus === 'DEFEAT'" type="danger" size="small">已驳回</el-tag>
              <el-tag v-else type="info" size="small">未知状态</el-tag>
            </span>
          </div>
          <div class="detail-item" v-if="refundAuditStatus !== ''">
            <span class="detail-label">退票审核状态</span>
            <span class="detail-value">
              <el-tag v-if="refundAuditStatus === 'SUCCESS'" type="success" size="small">已通过</el-tag>
              <el-tag v-else-if="refundAuditStatus === 'APPLYING'" type="warning" size="small">待审核</el-tag>
              <el-tag v-else-if="refundAuditStatus === 'DEFEAT'" type="danger" size="small">已驳回</el-tag>
              <el-tag v-else type="info" size="small">未知状态</el-tag>
            </span>
          </div>
          <div class="detail-item" v-if="invoiceStatus !== ''">
            <span class="detail-label">发票状态</span>
            <span class="detail-value">
              <el-tag :type="getInvoiceColor(invoiceStatus,'tagType')"
                :style="{color: getInvoiceColor(invoiceStatus,'color'),'background-color':getInvoiceColor(invoiceStatus,'backgroundColor')}">
                {{getInvoiceColor(invoiceStatus,'name')}}</el-tag>
            </span>
          </div>
          <div class="detail-item">
            <span class="detail-label">创建人</span>
            <span class="detail-value">{{ createBy }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">创建时间</span>
            <span class="detail-value">{{ createTime }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">发票记录ID</span>
            <span class="detail-value">{{ invoiceRecordId }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">发票金额</span>
            <span class="detail-value"><span class="amount-text">{{ formatAmount(invoiceAmount) }}</span></span>
          </div>
          <div class="detail-item">
            <span class="detail-label">发票抬头</span>
            <span class="detail-value">{{ invoiceTitle }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">开票单位</span>
            <span class="detail-value">{{ businessName }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">发票类型</span>
            <span class="detail-value">
              <el-tag v-if="invoiceType === '普票'" type="success" size="small">普票</el-tag>
              <el-tag v-else-if="invoiceType === '全电普票'" type="warning" size="small">全电普票</el-tag>
              <el-tag v-else-if="invoiceType === '专票'" color="#FFF9C4" size="small">专票</el-tag>
              <el-tag v-else-if="invoiceType === '全电专票'" size="small">全电专票</el-tag>
              <el-tag v-else-if="invoiceType === '电子普票'" color="#FFFFFF" size="small">电子普票</el-tag>
              <el-tag v-else type="info" size="small">未知类型</el-tag>
            </span>
          </div>
          <div class="detail-item" v-if="appendix !== ''">
            <span class="detail-label">附件</span>
            <span class="detail-value">
              <div class="attachment-actions">
                <el-button size="mini" type="primary" icon="el-icon-download" plain @click="download(id)">下载</el-button>
                <el-button size="mini" type="primary" icon="el-icon-view" plain @click="preview(id)">预览</el-button>
              </div>
            </span>
          </div>
          <div class="detail-item">
            <span class="detail-label">发票号码</span>
            <span class="detail-value">{{ invoiceNumber }}</span>
          </div>
          <div class="detail-item full-width">
            <span class="detail-label">备注</span>
            <span class="detail-value">{{ remark }}</span>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" type="primary" class="title" @click="cancel">确定</el-button>
    </div>
    <file-preview v-if="showFile" :show-dialog="showFile" :response="fileInfo" @submit="close"></file-preview>
  </el-dialog>
</template>

<script>

import FilePreview from "@/components/file/FilePreview.vue";
import {attachmentTickets} from "@/api/dilivery/tickets";
import InvoiceInfoDialog from "@/components/invoice/InvoiceInfoDialog";
import {getInvoiceColor} from "@/color";
import { getDataInLocalStorage } from "@/utils/localStorage";
import detailCommonMixin from "@/mixins/detailCommonMixin";

const baseURL = process.env.VUE_APP_BASE_API

export default {
  name: "TicketsDetails",
  components: {InvoiceInfoDialog, FilePreview},
  mixins: [detailCommonMixin],
  props:['showDialog','selectDetail','showPayment'],
  data(){
    return{
      title:'查看发票详情',
      showFile:false,
      fileInfo:'',
      id:'',
      createBy:'',
      createTime:'',
      invoiceAmount:'',
      invoiceNumber:'',
      invoiceRecordId:'',
      invoiceType:'',
      remark:'',
      invoiceStatus:'',
      refundAuditStatus:'',
      auditStatus:'',
      appendix:'',
      invoiceTitle: '',
      businessName: ''
    }
  },
  watch:{
    selectDetail:{
      handler(newVal){
        if(newVal&&Object.keys(newVal)){
          this.id = newVal.id
          this.createBy = newVal.createBy
          this.createTime = newVal.createTime
          this.invoiceAmount = newVal.invoiceAmount
          this.invoiceNumber = newVal.invoiceNumber
          this.invoiceRecordId = newVal.invoiceRecordId
          this.invoiceType = newVal.invoiceType
          this.remark = newVal.remark
          this.auditStatus = newVal.auditStatus
          this.invoiceTitle = newVal.invoiceTitle
          this.businessName = newVal['billingUnit'].companyName
          if(newVal.refundAuditStatus !== null){
            this.refundAuditStatus = newVal.refundAuditStatus
          }
          if(newVal.invoiceStatus !== null){
            this.invoiceStatus = newVal.invoiceStatus
          }
          if(newVal.appendix !== null){
            this.appendix = newVal.appendix
          }
        }
      },
      immediate:true
    }
  },
  mounted() {
  },
  methods:{
    getInvoiceColor,
    cancel(){
      this.$emit('submit','cancel')
    },
    
    async download(id) {
      try {
        let url = `${baseURL}/invoice-info/attachment/${id}?Authorization=${getDataInLocalStorage("token")}&Current-Role=${getDataInLocalStorage("role")}`
        const elink = document.createElement('a')
        elink.href = url
        document.body.appendChild(elink)
        elink.click()
        document.body.removeChild(elink);
      } catch (error) {
        console.log(error);
      }
    },
    async preview(id){
      try {
        this.fileInfo = await attachmentTickets(id);
        this.showFile = true
      } catch (error) {
        console.log(error);
      }
    }
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/detail.css";
</style>
